import { render, staticRenderFns } from "./deliveryDetailTable.vue?vue&type=template&id=200a7e77"
import script from "./deliveryDetailTable.vue?vue&type=script&lang=js"
export * from "./deliveryDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports